// src/theme.js — Microsoft Azure / Fluent Design inspired MUI theme
import { createTheme } from '@mui/material/styles';

export const azureColors = {
  primary: '#0078D4',
  primaryHover: '#106EBE',
  primaryDark: '#005A9E',
  accent: '#00BCF2',
  navy: '#00188F',
  text: '#242424',
  textSecondary: '#605E5C',
  border: '#EDEBE9',
  surface: '#FFFFFF',
  background: '#F3F2F1',
  backgroundAlt: '#FAF9F8',
  card: '#FFFFFF',
  footer: '#201F1E',
  success: '#107C10',
};

const fluentShadow = '0 1.6px 3.6px rgba(0,0,0,0.13), 0 0.3px 0.9px rgba(0,0,0,0.11)';
const fluentShadowHover = '0 3.2px 7.2px rgba(0,0,0,0.13), 0 0.6px 1.8px rgba(0,0,0,0.11)';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: azureColors.primary,
      light: azureColors.accent,
      dark: azureColors.primaryDark,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: azureColors.navy,
      contrastText: '#FFFFFF',
    },
    success: {
      main: azureColors.success,
    },
    background: {
      default: azureColors.background,
      paper: azureColors.surface,
    },
    text: {
      primary: azureColors.text,
      secondary: azureColors.textSecondary,
    },
    divider: azureColors.border,
  },
  typography: {
    fontFamily: [
      '"Segoe UI"',
      '"Segoe UI Web (West European)"',
      '-apple-system',
      'BlinkMacSystemFont',
      'Roboto',
      '"Helvetica Neue"',
      'sans-serif',
    ].join(','),
    h3: {
      fontWeight: 600,
      letterSpacing: '-0.02em',
      color: azureColors.text,
    },
    h4: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
      color: azureColors.text,
    },
    h5: {
      fontWeight: 600,
      color: azureColors.text,
    },
    h6: {
      fontWeight: 600,
      color: azureColors.text,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 2,
  },
  shadows: [
    'none',
    fluentShadow,
    fluentShadow,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
    fluentShadowHover,
  ],
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: azureColors.background,
          color: azureColors.text,
        },
        a: {
          color: azureColors.primary,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: azureColors.text,
          boxShadow: 'none',
          borderBottom: `1px solid ${azureColors.border}`,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 2,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        containedPrimary: {
          backgroundColor: azureColors.primary,
          '&:hover': {
            backgroundColor: azureColors.primaryHover,
          },
        },
        outlined: {
          borderColor: azureColors.border,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          border: `1px solid ${azureColors.border}`,
          boxShadow: fluentShadow,
          backgroundImage: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 2,
          fontWeight: 500,
        },
        outlinedPrimary: {
          borderColor: azureColors.primary,
          color: azureColors.primary,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        outlined: {
          borderColor: azureColors.border,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: azureColors.primary,
          textDecorationColor: 'rgba(0, 120, 212, 0.4)',
          '&:hover': {
            color: azureColors.primaryHover,
          },
        },
      },
    },
  },
});

export default theme;
